<template>
  <div  class="map-sidebar map-sidebar-filters" :class="{visible : showSidebar}" >
    <div class="header">
      <div class="sidebar-title">Filters</div>
      <div class="close-sidebar" @click="closeSidebar">
        <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M20.4006 20.5996C20.1403 20.8599 19.7181 20.8599 19.4578 20.5996L7.20128 8.34306C6.94093 8.08271 6.94093 7.6606 7.20128 7.40025C7.46163 7.1399 7.88374 7.1399 8.14409 7.40025L20.4006 19.6568C20.661 19.9171 20.661 20.3392 20.4006 20.5996Z" fill="white"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.2009 20.5996C6.94055 20.3393 6.94055 19.9172 7.2009 19.6568L19.4574 7.40031C19.7178 7.13996 20.1399 7.13996 20.4002 7.40031C20.6606 7.66066 20.6606 8.08277 20.4002 8.34312L8.14371 20.5996C7.88336 20.86 7.46125 20.86 7.2009 20.5996Z" fill="white"/>
        </svg>
    </div>
    </div>
    <div class="sidebar-content">
      <div class="filter-info-label">
        Hoe werkt ARK aan wilde natuur?
      </div>
      <div>Om de ontwikkeling van wilde natuur een zetje te geven, herstellen we natuurlijke processen die bij een gebied horen. Kan water in- en uitstromen? Werken natuurlijke kringlopen nog? Missen er sleutelsoorten in het gebied? Filter hieronder om te zien in welke gebieden we waar aan werkten.</div>
      <div class="filter-container">
        <div class="filter-row" v-for="filter in filters" :key="filter.tid" >
          <svg @click="toggleFilter(filter.tid)" class="filter"  width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="10" cy="10" r="9.5" fill="white" stroke="#BBCDCE"/>
            <circle class="filter-circle" :class="{checked: filter.checked}" cx="10" cy="10" r="7"/>
          </svg>
          <span @click="toggleFilter(filter.tid)" class="filter-name">
                 {{filter.name}}
          </span>
          <svg @click="toggleFilter(filter.tid)" width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M20.0625 10.0001C20.0625 15.2468 15.8092 19.5001 10.5625 19.5001C5.31579 19.5001 1.0625 15.2468 1.0625 10.0001C1.0625 4.75336 5.31579 0.500061 10.5625 0.500061C15.8092 0.500061 20.0625 4.75336 20.0625 10.0001Z" :fill="'url(#paint0_linear_15_1133' + filter.tid + ')'" stroke="#0A5256"/>
            <defs>
              <linearGradient :id="'paint0_linear_15_1133' + filter.tid" x1="10.5625" y1="6.10352e-05" x2="10.5625" y2="20.0001" gradientUnits="userSpaceOnUse">
                <stop :stop-color="filter.color"/>
                <stop offset="1" :stop-color="filter.offset_color"/>
              </linearGradient>
            </defs>
          </svg>
          <svg class="filter-link" @click.prevent="showTag(filter.tid)" width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.863 11.8885V17.8885M20.863 11.3885C20.863 16.9113 16.3858 21.3885 10.863 21.3885C5.34013 21.3885 0.862976 16.9113 0.862976 11.3885C0.862976 5.86564 5.34013 1.38849 10.863 1.38849C16.3858 1.38849 20.863 5.86564 20.863 11.3885ZM12.863 6.88849C12.863 7.99306 11.9675 8.88849 10.863 8.88849C9.75841 8.88849 8.86298 7.99306 8.86298 6.88849C8.86298 5.78392 9.75841 4.88849 10.863 4.88849C11.9675 4.88849 12.863 5.78392 12.863 6.88849Z" stroke="black" stroke-linecap="round"/>
          </svg>


        </div>
      </div>
      <div class="filter-info-label">
        Alles of actief:
      </div>
      <div>Wil je alle plekken zien waar ARK in de afgelopen 35 jaar werkte (alles), of alleen waar we op dit moment actief zijn (actief)?
      </div>
      <div class="active-toggle-wrapper">
        <span>alles</span>
          <svg @click="checked = !checked" width="74" height="28" viewBox="0 0 74 28" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="73" height="27" rx="13.5" fill="white" stroke="#BBCDCE"/>
            <path class="activeToggle" :class="{active:active}" d="M23.5 14C23.5 19.2467 19.2467 23.5 14 23.5C8.7533 23.5 4.5 19.2467 4.5 14C4.5 8.75329 8.7533 4.5 14 4.5C19.2467 4.5 23.5 8.75329 23.5 14Z" fill="#0A5256" stroke="#BBCDCE"/>
          </svg>
        <span>actief</span>
      </div>



    </div>

  </div>
</template>

<script setup>
import { onMounted, ref, watch } from 'vue';


defineProps({
  filters: Array,
  active: Boolean
});

const showSidebar = ref(false);

const checked = ref(false);

const emit = defineEmits(['toggle-filter', 'set-active', 'close', 'show-tag']);

watch(checked, (currentValue, oldValue) => {
  emit('set-active', currentValue);
});


function closeSidebar() {
  showSidebar.value = false;
  window.setTimeout(() => {
    emit('close');
  }, 300);
}

onMounted(() => {
  window.setTimeout(() => {
    showSidebar.value = true;
  }, 50);
})



function showTag(tid) {
  emit('show-tag', tid);
}

function toggleFilter(tid) {
  emit('toggle-filter', tid);
}

defineExpose({
  showSidebar
});


</script>



